import { useAtom } from 'jotai';
import { useHistory } from 'react-router-dom';
import { EvaluationResult } from './index';
import { usePackageEvaluation } from './atoms';

export type EvaluationVersion = '2.0' | '3.0';

interface EvaluationVersionSwitcherProps {
  isCombined?: boolean;
}

/**
 * Data-fetching wrapper for EvaluationResult (Eval 2.0 view).
 * Loads the packageEvaluation from the current URL and passes it to
 * EvaluationResult.
 *
 * @param {EvaluationVersionSwitcherProps} props - Component props.
 * @return {JSX.Element} The EvaluationResult component.
 */
export const EvaluationVersionSwitcher = ({
  isCombined = false,
}: EvaluationVersionSwitcherProps) => {
  const { location } = useHistory();
  const packageEvaluationAtom = usePackageEvaluation(
    `${location.pathname}${location.search}`
  );

  const [packageEvaluation, getPackageEvaluation] = useAtom(
    packageEvaluationAtom
  );

  return (
    <EvaluationResult
      isCombined={isCombined}
      packageEvaluation={packageEvaluation}
      getPackageEvaluation={getPackageEvaluation}
    />
  );
};
